angular.module("vgresiduos").controller("mtrSystemLoginEditCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "organizacao/integracoes/login/" + $stateParams.id, []);
		};
	}
]);
